import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import { RouteComponentProps, Redirect } from 'react-router'
import { TripStatuses } from '../../constants/trip-statuses'
import { IActiveTripResponseV2 } from '../../types'
import Modal from '../ui/Modal'
import UIMessages from '../../utils/ui-messages'

interface IRouteParams {
  tripId: string
}

interface IManualTripNoShowModalProps extends RouteComponentProps<IRouteParams> {
  currentTrip: IActiveTripResponseV2
  loading: boolean
  noShowTrip: (tripId: string, comment: string) => Promise<any>
  getTripById: (tripId: string) => Promise<any>
  close: () => void
}

interface IManualTripNoShowModalState {
  reason: string
  otherReason: string
}

export default class ManualTripNoShowModal extends React.Component<
  IManualTripNoShowModalProps,
  IManualTripNoShowModalState
> {
  constructor(props: IManualTripNoShowModalProps) {
    super(props)

    this.state = {
      reason: '',
      otherReason: ''
    }
  }

  public render() {
    const currentTripStatus = this.props.currentTrip.lastStatus
    const tripStatus = currentTripStatus

    if (
      tripStatus === TripStatuses.REQUESTED ||
      tripStatus === TripStatuses.COMPLETED ||
      tripStatus === TripStatuses.CANCELLED ||
      tripStatus === TripStatuses.MANUALLY_COMPLETED
    ) {
      return <Redirect to={`/trips/${this.props.currentTrip.id}`} />
    }
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-4 p2'>
            <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 mb1 h3'>
              {UIMessages.manualTripNoShow.modalTitle}
            </span>
            <div className='mt1'>
              <span>{UIMessages.manualTripNoShow.reasonQuestion}</span>
              <div className='mt1' onChange={this.handleSelect}>
                {UIMessages.manualTripNoShow.noShowReasons.map((reason, i) => (
                  <div key={i}>
                    <label>
                      <input type='radio' name='reason' value={reason} />
                      <span>{reason}</span>
                    </label>
                  </div>
                ))}
              </div>
              <div className='mb1' onChange={this.handleOtherReasonUpdate}>
                <textarea className='col-12 p1 fit' value={this.state.otherReason} />
              </div>
            </div>
            <div className='mt1'>
              <button
                type='button'
                onClick={this.props.close}
                className='CancelButton btn bg-white rounded font-light-grey mr2'
              >
                {UIMessages.common.cancel}
              </button>
              <button
                type='submit'
                className='SubmitButton btn bg-green rounded weight-300'
                onClick={this.noShowTrip}
                disabled={this.props.loading}
              >
                <span className='font-white flex items-center'>
                  Submit
                  {this.props.loading ? (
                    <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
                  ) : (
                    <React.Fragment />
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleSelect = (event: any) => {
    this.setState({
      reason: event.target.value
    })
  }

  private handleOtherReasonUpdate = (event: any) => {
    this.setState({
      otherReason: event.target.value
    })
  }

  private noShowTrip = () => {
    const comment = this.state.otherReason ? this.state.otherReason : ''
    this.props.noShowTrip(this.props.currentTrip.id, this.state.reason + ', ' + comment).then(() => {
      this.props.getTripById(this.props.currentTrip.id)
      this.props.close()
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/ManualTripNoShowModal.tsx